import { render, staticRenderFns } from "./fieldServer.vue?vue&type=template&id=5fab2d11&scoped=true&"
import script from "./fieldServer.vue?vue&type=script&lang=js&"
export * from "./fieldServer.vue?vue&type=script&lang=js&"
import style0 from "./fieldServer.vue?vue&type=style&index=0&id=5fab2d11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fab2d11",
  null
  
)

export default component.exports